<template>
  <div>
    <span class="login__username">{{username}}</span>
    <span class="login__email">
      <div class="login__envelope"></div>{{email}}
    </span>
    <span class="login__title">twoje notowania</span>

    <div class="notes__menu">
      <span
        :class="['login__subtitle', {'login__subtitle--active' : listType === 1}]"
        v-on:click="listType=1; singleNote=false"
      >lista przebojów 3</span>
      <span
        :class="['login__subtitle', {'login__subtitle--active' : listType === 2}]"
        v-on:click="listType=2; singleNote=false"
      >top wszech czasów</span>
      <span
        :class="['login__subtitle', {'login__subtitle--active' : listType === 3}]"
        v-on:click="listType=3; singleNote=false"
      >polski top wszech czasów</span>
    </div>

    <div class="login__section">
      <div class="notes__table" v-if="singleNote==false">
        <div class="table__row table__row--top">
          <span class="table__column table__column--1">notowanie</span>
          <span class="table__column table__column--2">data notowania</span>
          <span class="table__column table__column--3">oddane głosy</span>
          <span class="table__column table__column--4"></span>
        </div>
        <div class="table__row" v-for="(list, index) in lists" :key="list.listId">
          <span class="table__column table__column--1">{{list.number}}</span>
          <span class="table__column table__column--2">{{list.date}}</span>
          <span
            class="table__column table__column--3"
          >{{list.numberOfVotes}}/{{list.availableNumberOfVotes}}</span>
          <span
            class="table__column table__column--4"
            v-on:click="loadSingleNote(list.listId, index)"
          >WIĘCEJ</span>
        </div>

        <div class="notes__pagination" v-if="pagesNr>1">
          <span
            class="notes__arrow notes__arrow--left"
            v-on:click="currentPage > 1?currentPage--:null"
          ></span>
          <span class="pagination__numbers">{{currentPage}}/{{pagesNr}}</span>
          <span
            class="notes__arrow notes__arrow--right"
            v-on:click="currentPage < pagesNr?currentPage++:null"
          ></span>
        </div>
      </div>

      <div class="notes__votes" v-if="singleNote">
        <div class="note__menu">
          <span class="notes__arrow notes__arrow--left" v-on:click="loadSingleNote(lists[singleNote[1]-1].listId, singleNote[1]-1)"></span>
          <div class="note__container">
            <span>notowanie</span>
            <span v-on:click="goToNote(lists[singleNote[1]].number)">{{singleNote[0].number}}</span>
          </div>
          <div class="note__container">
            <span>data notowania</span>
            <span>{{singleNote[0].date}}</span>
          </div>
          <div class="note__container">
            <span>oddane głosy</span>
            <span>{{singleNote[0].numberOfVotes}}/{{singleNote[0].availableNumberOfVotes}}</span>
          </div>
          <span class="notes__arrow notes__arrow--right"  v-on:click="loadSingleNote(lists[singleNote[1]+1].listId, singleNote[1]+1)"></span>
        </div>

        <div class="single__vote" v-for="(note, index) in singleNoteList" :key="index">
          <div class="vote__index">{{index+1}}</div>
          <img :style="{backgroundImage: 'url(' + note.artists[0].photo + ')'}" class="vote__img" />
          <div class="vote__content">
            <div class="vote__titles">
              <span
                class="vote__name"
                v-on:click="goToArtistSite(note.artists[0].id)"
              >{{note.artists[0].name}}</span>
              <span class="vote__song" v-on:click=" goToSong(note.id)">{{note.name}}</span>
            </div>
          </div>
          <div class="vote__play">
            
            <i
              class="material-icons"
              v-if="playingNow == index"
              v-on:click="playMP3(note.mp3Path); if (playingNow == index) playingNow = 9999"
              tabindex="0"
              aria-label="Pauza"
            >pause_circle_outline</i>
            <i
              v-else
              class="material-icons"
              v-on:click="playMP3(note.mp3Path); playingNow = index"
              tabindex="0"
              aria-label="Odtwórz"
            >play_circle_outline</i>
          </div>
        </div>
        <audio src="" ref="audio"></audio>
    
         <div class="notes__pagination" v-if="singleNotePagesNr > 1">
          <span
            class="notes__arrow notes__arrow--left"
            v-on:click="singleNoteCurrentPage > 1? singleNoteCurrentPage--:null"
          ></span>
          <span class="pagination__numbers">{{singleNoteCurrentPage}}/{{singleNotePagesNr}}</span>
          <span
            class="notes__arrow notes__arrow--right"
            v-on:click="singleNoteCurrentPage < singleNotePagesNr?currentPage++:null"
          ></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mixin from "../mixin";

export default {
  mixins: [mixin],
  components: {},

  methods: {},
  mounted() {}
};
</script>

<style scoped lang="scss">
.note__menu {
  display: flex;
  justify-content: center;
  margin: 1rem;
}
.note__container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 0 1.5rem;
  height: 1.8rem;
    justify-content: space-between;
}

.note__container span:nth-child(2) {
   
font-size: 0.8rem;
    font-weight: 600;
}

.note__container span:first-child {
   text-transform: uppercase;
    font-size: 0.6rem;
}


.note__container:nth-child(2) span:nth-child(2) {
      font-size: 1.2rem;
    font-weight: 600;
    color: purple;
      cursor: pointer;


}
.vote__play {
  background-color: #eee;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  min-width: 16%;
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
  color: #e22a60;
  cursor: pointer;
  border-left: 1px solid #d6d6d6;
  position: absolute;
  right: 0;
  height: 100%;
}
.vote__titles {
  display: flex;
  flex-direction: column;
}
.single__vote {
  width: 100%;
  height: 2.5rem;
  background-color: #fefefe;
  margin: 0.5rem 0;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  border-radius: 5px;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  align-items: center;
  position: relative;
}
.vote__index {
  height: 100%;
  min-width: 4rem;
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
  background-color: #efeeee;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  color: #acacac;
  font-family: Poppins, sans-serif;
  font-size: 2rem;
  font-weight: 700;
}
.vote__img {
  width: 4rem;
  height: 90%;
  margin: 0 0.5rem;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border: 1px solid #e13368;
  position: relative;
  background-position: 50%;
  background-repeat: no-repeat;
  background-size: 100%;
}
.vote__name {
  font-family: Poppins, sans-serif;
  color: #0f1626;
  font-size: 0.7rem;
  line-height: 1.2;
  font-weight: 700;
  cursor: pointer;
  white-space: nowrap;
  width: 100%;
  height: 1rem;
  position: relative;
}
.vote__song {
  font-size: 0.6rem;
}

.login__envelope {
  background-image: url(../../../assets/editprofile__envelope.png);
  width: 12px;
  height: 8px;
  background-size: cover;
  background-position: center;
  margin-right: 1em;
  cursor: pointer;
}
.notes__arrow {
  display: block;
  width: 2rem;
  height: 2rem;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  &--left {
    background-image: url("../../../assets/arrow--left.png");
    &:hover {
      background-image: url("../../../assets/arrow__hover--left.png");
    }
  }
  &--right {
    background-image: url("../../../assets/arrow--right.png");
    &:hover {
      background-image: url("../../../assets/arrow__hover--right.png");
    }
  }
}
.pagination__numbers {
  margin: 0 5%;
  font-size: 0.8rem;
}
.table__column {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  &--1 {
    width: 17%;
    margin-right: 2px;
  }
  &--2 {
    width: 32.5%;
    margin-right: 2px;
  }
  &--3 {
    width: 32.5%;
  }
  &--4 {
    width: 17%;
  }
}

.table__row {
  height: 1.5rem;
  display: flex;
  align-items: center;
  &--top {
    text-transform: uppercase;
    font-size: 0.6rem;
  }
  &:not(.table__row--top) {
    margin: 0.3rem 0;
    .table__column {
      font-size: 0.7rem;
      font-weight: 600;
      background-color: #efedee;
      &--1 {
        color: #c673e7;
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
      }
      &--4 {
        color: #8f90af;
        font-size: 0.6rem;
        background-color: #d1d0e0;
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
        cursor: pointer;
        &:hover {
          background-color: #df2860;
          color: white;
        }
      }
    }
  }
}
.notes {
  &__menu {
    display: flex;
    justify-content: space-between;
    width: 94%;
    margin: 0 3%;
  }

  &__table {
    margin-top: 0.5rem;
  }
  &__pagination {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    margin: 1.5rem 0;
  }
  &__votes {
        padding-bottom: 3rem;
  }
}
.login {
  &__section {
    width: 94%;
    margin-left: 3%;
    border-top: 1px solid #cfd1e0;
    margin-top: -1px;
  }
  &__subtitle {
    display: block;
    margin-top: 1.5rem;
    text-transform: uppercase;
    font-weight: 600;
    font-size: 0.9rem;
    width: fit-content;
    padding-bottom: 0.3rem;
    color: #cfd1e0;
    cursor: pointer;
    &--active {
      border-bottom: 4px solid #df2860;
      color: black;
    }
    @media (max-width: 990px) {
    font-size: 0.7rem;
    }
  }

  &__username {
    display: block;
    margin-left: 3%;
    font-size: 1.5rem;
    margin-top: 2rem;
  }

  &__email {
    display: flex;
    margin-left: 3%;
    align-items: center;
    font-size: 0.7rem;
    margin-top: 0.7rem;
    height: 1.1rem;
  }

  &__button {
    position: absolute;
    bottom: 1.5em;
    left: 20%;
    width: 60%;
    height: 2rem;
    text-transform: uppercase;
    font-size: 0.7rem;
    border: none;
    background-color: #df2860;
    color: #fafafa;
    border-radius: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 2rem;
    font-family: "Poppins", sans-serif;
    text-transform: uppercase;
    cursor: pointer;
    &--gradient {
      background-color: #af2f82;
      background-image: linear-gradient(to right, #df2860, #af2f82);
      width: fit-content;
      padding: 0 15px;
      right: 3%;
      left: auto;
    }
  }

  &__title {
    font-family: "Poppins";
    color: white;
    font-family: "Poppins";
    color: white;
    display: flex;
    height: 2rem;
    background-color: #df2860;
    width: 25%;
    text-transform: uppercase;
    align-items: center;
    margin-top: 3rem;
    padding-left: 3%;
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
    @media (max-width: 990px) {
      width: 30%;
      font-size: 0.8rem;
    }
  }
  
}
</style>